import React, {Component} from 'react';


export class InputNumber extends Component
{
    state = {
        value: 0
    };


    componentDidMount() {
        const {selected} = this.props;
        this.setState({value: selected && selected.length > 0 ? selected[0].value : 0});
    }


    handleChange(v){
        const {options} = this.props;

        this.setState({value: v < 0 ? 0 : v > 100 ? 100 : v });
        this.props.onChange({...options[0], value: v});
    }


    render()
    {
        let {value} = this.state;

        return (
           <div className="d-flex">
               <div className={"input-number-sub"} onClick={() => this.handleChange(--value)}>-</div>
               <input type='number' className={"text-center input-number"} min={0} max={100} value={value} onChange={e => this.handleChange(e.target.value)}/>
               <div className={"input-number-add"} onClick={() => this.handleChange(++value)}>+</div>
           </div>
        );
    }
}
